import { isValidDocument } from "../../../shared/utility"

export const isDocumentSectionCompleted = (data) => {
    if(!data) return false
    const {privacy_act} = data
    //const {payroll_receipt, rent_payment_receipt, property_ticket, privacy_act} = data

    return isValidDocument(privacy_act) 
}